import './social-network-transfer-actions.ajscss';

import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { ISocialNetworkFrameService } from '@agent/agent-interface/contact-view/social-network/services/social-network-frame.service';
import { ITransferDeprecatedService } from '@agent/core/contact/transfer/transfer-deprecated.service';
import { IConferenceDeprecatedService } from '@agent/core/phone/conference/conference-deprecated.service';
import { ToastDeprecatedService } from '@commons/core/notification/toast-deprecated.service';
import { IComponentController, IComponentOptions, ILogService } from 'angular';
import { i18n } from 'i18next';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

import templateUrl from './social-network-transfer-actions.template.html';

const MODULE_NAME = 'socialNetworkTransferActions';

export class SocialNetworkTransferActionsCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  protected enableValidateBtn = true;
  private isConference: string;

  constructor(
    private readonly $log: ILogService,
    private readonly $i18next: i18n,
    private readonly transferDeprecatedService: ITransferDeprecatedService,
    private readonly toastDeprecatedService: ToastDeprecatedService,
    private readonly conferenceDeprecatedService: IConferenceDeprecatedService,
    private readonly socialNetworkFrameService: ISocialNetworkFrameService,
    private readonly router: AgentDesktopRouter
  ) {
    super();
  }

  $onInit() {}

  get canValidate(): boolean {
    // if form is valid
    if (this.enableValidateBtn) {
      return this.transferDeprecatedService.canValidateTransfer(this.responseId);
    }

    // if no validate already in progress
    return this.enableValidateBtn;
  }

  validate(): void {
    if (this.enableValidateBtn) {
      this.enableValidateBtn = false;
      this.transferDeprecatedService.validateTransfer(this.responseId).then(
        response => {
          if (!response || response.status !== 200) {
            // if error in http call reactivate validate button
            this.enableValidateBtn = true;
            this.toastDeprecatedService.alert(this.$i18next.t('agent:contact.workspace.transfer.toast.error'));
          } else {
            this.$log.debug('[contactSocialNetworkTransferActions]Transfer request sent');
            const transferMessage = this.transferDeprecatedService.getTransfer(this.responseId).get().comment;
            if (transferMessage) {
              this.socialNetworkFrameService.haveOpenSocialNetwork();
            }
          }
        },
        () => {
          // if error in http call reactivate validate button
          this.enableValidateBtn = true;
          this.toastDeprecatedService.alert(this.$i18next.t('agent:contact.workspace.transfer.toast.error'));
        }
      );
    } else {
      this.$log.info('[contactSocialNetworkTransferActions]transfer action already in progress');
    }
  }

  cancel(): void {
    this.transferDeprecatedService.cancelTransfer(this.responseId).then(() => {
      this.enableValidateBtn = true;
      this.router.navigateFromLastChild(['../..']);
    });
  }

  validateTransfer(guestId: string): void {
    this.enableValidateBtn = false;
    this.conferenceDeprecatedService.validateTransfer(this.responseId, guestId).then(
      () => {
        this.toastDeprecatedService.notify(this.$i18next.t('agent:contact.workspace.transfer.toast.complete'), 5000);
      },
      () => {
        this.enableValidateBtn = true;
      }
    );
  }
}

export class SocialNetworkTransferActions implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
    isConference: '<',
  } as { [binding: string]: string };
  controller = [
    '$log',
    '$i18next',
    'transferDeprecatedService',
    'toastDeprecatedService',
    'conferenceDeprecatedService',
    'socialNetworkFrameService',
    'agentDesktopRouter',
    SocialNetworkTransferActionsCtrl,
  ];
}

export default MODULE_NAME;
